import { Link } from "react-router-dom";
import logo from "../assets/favicon_no_B.PNG";

const services = [
  { name: "ComHab Directory", path: "/comhab", icon: "🙋‍♂️" },
  { name: "Respite Directory", path: "/respite", icon: "🏠" },
  { name: "Join Directory", path: "/join-dsp-network", icon: "📝" },
  { name: "Families Seeking Support", path: "/families-seeking-support", icon: "👨‍👩‍👧‍👦" },
  { name: "Self-Direction Resources", path: "/opwdd", icon: "📘" },
  { name: "Broker Resources", path: "/broker", icon: "🤝" },
  { name: "List of Fiscal Intermediary", path: "/fi", icon: "💼" },
  { name: "Activities Near You", path: "/activities", icon: "📍" },
  //{ name: "Help / FAQ", path: "/faq", icon: "❓" },
    { name: "Residential Cleaning Services", path: "/cleaning", icon: "🧹" },
];

export default function Home() {
  return (
    <section
      className="home-page"
      style={{
        paddingTop: "10px"   // reduces space under navbar
      }}
    >

      {/* centered logo */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "5px",
          marginBottom: "15px"
        }}
      >
        <img
          src={logo}
          alt="Hopeful Horizons logo"
          style={{
            width: "300px",   // slightly smaller looks more balanced
            maxWidth: "85%",
            display: "block"
          }}
        />
      </div>

      {/* optional title */}
      {/* <h1 className="home-title">Support Services Directory</h1> */}

      <div className="services-grid">
        {services.map((service, index) => (
          <Link
            key={`${service.name}-${index}`}
            to={service.path}
            className="service-box"
          >
            <div className="service-content">
              <div className="service-icon">{service.icon}</div>
              <div className="service-name">{service.name}</div>
            </div>
          </Link>
        ))}
      </div>

    </section>
  );
}